<!-- 発駅を選択する必要がある商材の場合はidを直接指定して分岐をかけているので注意 -->
<template>
  <div>
    <!-- masterBookSetがある || masterBookに中身が入ったら 描画されるテンプレート -->
    <TemplateBookBooking v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import TemplateBookBooking from "@/views/Templates/TicketStore/TemplateBookBooking";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "BookBooking",
  components: {
    TemplateBookBooking: TemplateBookBooking,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      try {
        //Androidでチケット規約を開くとstoreがリセットされるので、ここでチケット情報を再取得
        if (route.query.master_book_set_id) {
          await API.getMasterBookSet(route.query.master_book_set_id);
        } else {
          await API.getMasterBook(route.params.id);
        }
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "BookBooking onMounted()",
          JSON.stringify(err)
        );
      }
    });

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterBookSet = computed(
      () => store.getters["ticketing/masterBookSet"]
    );

    watchEffect(() => {
      if (masterBook.value.length !== 0 || masterBookSet.value !== null) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
